import React, { Component } from "react";
import { getCardTrade } from "../services/cardTradeService";
import auth from "../services/authService";
import Spinner from "./common/spinner";
import NotFound from "./notFound";
import moment from "moment";
import ModalImage from "react-modal-image";
import { Link } from "react-router-dom";

import {
  tradeCompletionStatus,
  tradeApprovalStatus,
} from "../services/cardTradeService";
import { saveCredit } from "../services/creditService";

class GTradeInfo extends Component {
  state = {
    loading: false,
    card_value: "",
    cardBrand: "",
    cardRange: "",
    cardCountry: "",
    cardType: "",
    amountToReceive: "",
    trade_reference: "",
    approvedBy: "",
    closedBy: "",
    approve_status_updated_at: "",
    close_status_updated_at: "",
    image: [],
    isApproved: false,
    isCompleted: false,
    _id: "",
    user: "",
    createdAt: "",
    funded: false,
    final_amount: 0,
  };

  async componentDidMount() {
    const tradeId = this.props.match.params.id;

    this.setState({ loading: true });
    const {
      _id,
      card_value,
      cardBrand,
      cardRange,
      cardCountry,
      cardType,
      cardNote,
      amountToReceive,
      trade_reference,
      approvedBy,
      closedBy,
      approve_status_updated_at,
      close_status_updated_at,
      image,
      isApproved,
      isCompleted,
      user,
      funded,
      created_at,
    } = (await getCardTrade(tradeId)).data.data;
    console.log((await getCardTrade(tradeId)).data.data);
    this.setState({ loading: false });
    this.setState({
      _id,
      card_value,
      cardBrand,
      cardRange,
      cardCountry,
      cardType,
      cardNote,
      amountToReceive,
      trade_reference,
      approvedBy,
      closedBy,
      approve_status_updated_at,
      close_status_updated_at,
      image: image ? image : [],
      isApproved,
      isCompleted,
      user,
      funded,
      created_at,
    });
  }

  handleTradeCompletionSwitch = async (gtrade) => {
    this.setState({ loading: true });
    await tradeCompletionStatus(gtrade);
    this.setState({ gtrade });
    this.setState({ loading: false });
  };

  handleTradeApprovalSwitch = async (gtrade) => {
    this.setState({ loading: true });

    await tradeApprovalStatus(gtrade);
    this.setState({ gtrade });
    this.setState({ loading: false });
  };
  handleWallet = async (gtrade) => {
    this.setState({ loading: true });
    if (gtrade.amount > this.state.amountToReceive) {
      alert("invalid amount passed, please input the correct value");
      this.setState({ loading: false });
    } else {
      gtrade.tradeTypeId = "5ed17e097ab3831916935d4f";
      await saveCredit(gtrade);
      this.setState({ gtrade });
      this.setState({ loading: false });
    }
  };

  approve = async (gtrade) => {
    await tradeApprovalStatus(gtrade);
  };

  getPagedData = () => {
    const { users } = this.state;

    return { data: users };
  };

  render() {
    const {
      _id,
      loading,
      card_value,
      cardBrand,
      cardRange,
      cardCountry,
      cardType,
      cardNote,
      amountToReceive,
      trade_reference,
      approvedBy,
      closedBy,
      approve_status_updated_at,
      close_status_updated_at,
      image,
      isApproved,
      isCompleted,
      user,
      funded,
      final_amount,
      created_at,
    } = this.state;
    console.log(_id, "idd");
    const { isAdmin } = auth.getCurrentUser();
    return isAdmin ? (
      <React.Fragment>
        {loading && <Spinner message="" />}
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">Fund Wallet</h6>
          </div>

          <div className="card-body">
            <div className="form-group">
              <input
                type="number"
                className="form-control"
                onInput={(e) => {
                  this.setState({ final_amount: e.target.value });
                }}
                disabled={funded}
              />
            </div>

            {!funded ? (
              <button
                className="btn btn-primary"
                style={{ marginLeft: 20 }}
                onClick={async () => {
                  this.setState({ loading: true });
                  await this.handleWallet({
                    amount: final_amount,
                    trade_reference: trade_reference,
                    user_email: user,
                  });
                  this.setState({ funded: true, loading: false });
                }}
              >
                Fund User Wallet
              </button>
            ) : (
              <button
                className="btn btn-primary"
                style={{ marginLeft: 20 }}
                disabled={true}
              >
                Funded User Wallet
              </button>
            )}
          </div>
        </div>
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">
              {trade_reference}
            </h6>
          </div>
          <div className="action_buttons" style={{ marginTop: 10 }}>
            <div>
              {isApproved ? (
                <button
                  className="btn btn-primary"
                  style={{ marginLeft: 20 }}
                  onClick={async () => {
                    this.setState({ loading: true });
                    await this.handleTradeApprovalSwitch({
                      _id: _id,
                      isApproved: false,
                    });
                    this.setState({ isApproved: false, loading: false });
                  }}
                >
                  Disapprove Trade
                </button>
              ) : (
                <button
                  className="btn btn-primary"
                  style={{ marginLeft: 20 }}
                  onClick={async () => {
                    this.setState({ loading: true });
                    const re = await this.handleTradeApprovalSwitch({
                      _id: _id,
                      isApproved: true,
                    });
                    this.setState({ isApproved: true, loading: false });
                  }}
                >
                  Approve Trade
                </button>
              )}
              {
                // isCompleted ? (
                // <button
                //   className="btn btn-primary"
                //   style={{ marginLeft: 10, background: "red" }}
                //   onClick={async () => {
                //     this.setState({ loading: true });
                //     await this.handleTradeCompletionSwitch({
                //       _id: _id,
                //       isCompleted: false,
                //     });
                //     this.setState({ isCompleted: false, loading: false });
                //   }}
                // >
                //   Open Trade
                // </button>
                //   <></>
                // ) : (
                // <button
                //   className="btn btn-primary"
                //   style={{ marginLeft: 10, background: "red" }}
                //   onClick={async () => {
                //     this.setState({ loading: true });
                //     await this.handleTradeCompletionSwitch({
                //       _id: _id,
                //       isCompleted: true,
                //     });
                //     this.setState({ isCompleted: true, loading: false });
                //   }}
                // >
                //   Close Trade
                // </button>
                <Link
                  to={`/closed-trades/${_id}`}
                  className="btn btn-danger"
                  style={{ marginLeft: 20 }}
                >
                  Close Trade
                </Link>
                // )
              }
            </div>
          </div>
          <div className="card-body">User email: {user}</div>
          <div className="card-body">Card Value: {card_value}</div>
          <div className="card-body">Amount to Receive: ₦{amountToReceive}</div>
          <div className="card-body">Card Type: {cardType}</div>
          <div className="card-body">Card Country: {cardCountry}</div>
          <div className="card-body">Card Brand: {cardBrand}</div>
          <div className="card-body">Card Range: {cardRange}</div>
          <div className="card-body">Trade Ref: {trade_reference}</div>
          <div className="card-body">Trade Note: {cardNote}</div>
          <div className="card-body">
            User Submitted trade at : {moment(created_at).format("LLLL")}
          </div>
          {approvedBy && approve_status_updated_at && (
            <div className="card-body">
              Trade Approval Status Updated By: {approvedBy} on{" "}
              {moment(approve_status_updated_at).format("LLLL")}
            </div>
          )}
          {closedBy && close_status_updated_at && (
            <div className="card-body">
              Trade Completion Status Updated By: {closedBy} on{" "}
              {moment(close_status_updated_at).format("LLLL")}
            </div>
          )}
          {image.map((value, index) => {
            return (
              <div key={index}>
                {image && value.location && (
                  <div
                    className="mt-4 ml-4"
                    style={{ color: "#000524", fontWeight: "bold" }}
                  >
                    Uploaded Proof
                  </div>
                )}
                {value.location && (
                  <div className="col-md-6 mt-4 mb-4">
                    <ModalImage
                      small={value.location}
                      large={value.location}
                      alt="Uploaded Proof"
                      showRotate={true}
                      hideZoom={true}
                      className="trade-image"
                    />
                  </div>
                )}
              </div>
            );
            // );
          })}
        </div>
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default GTradeInfo;
